<template>
    <div class="operateSitesWrap">
        <div class="row-item mr-10" v-for="shop in shopList" :key="shop.id">
            <el-image :src="shop.icon" style="width: 26px; height: 26px; border-radius: 50%"></el-image>
            <span class="shop-title">{{ shop.shortTitle || shop.title }}</span>
            <el-select v-model="valueMap[shop.id]" placeholder="请选择" filterable multiple collapse-tags value-key="siteId" width="250px">
              <el-option v-for="item in siteList" :key="item.siteId" :label="item.siteName" :value="item"></el-option>
            </el-select>
            <span v-if="getFail[shop.id]" style="color: red;margin-left: 10px; font-size: 12px;">店铺授权已失效</span>
        </div>
    </div>
</template>

<script>
import { getSites } from '@/servers/prod/center/temu.js';
export default {
    name: 'OperateSites',
    model: {
        prop: 'value',
        event: 'change',
    },
    props:{
        shopList: {
            type: Array,
            default() {
                return [];
            },
        },
        value:{
            type:Array,
            default(){
                return []
            }
        },
    },
    data(){
        return {
            siteList:[],
            valueMap:{},
            getFail:{}
        }
    },
    methods:{
        init(){
            let _valueMap = {}
            this.geSiteList();
            this.shopList.forEach(shop => {
                _valueMap[shop.id] = []
            });
            this.$set(this,valueMap,_valueMap)
        },
        // 获取经营站点
        geSiteList(keyword){
            let params = {
                keyword:''
            }
            getSites(params).then(res => {
                if(res){
                    this.siteList = res
                }
            })
        },
    },
    created(){
        this.init();
    }
}
</script>

<style lang="scss" scoped>
.operateSitesWrap{
    display: flex;
    flex-wrap: wrap;
    .row-item{
        display: flex;
        align-items: center;
        margin-bottom: 10px;

    }
}
</style>
    
const ProTableDemo = () => {
  const columns: ProColumnsType<any> = [
    {
      title: 'number',
      dataIndex: 'app.id',
      fixed: 'left',
      width: 100,
      type: 'number',
    },
    {
      title: 'number',
      dataIndex: 'num',
      key: 'hideNumber',
      fixed: 'left',
      type: 'number',
      width: 200,
    },
    {
      title: 'number',
      type: 'numberRange',
      getValue(record, index) {
        return [1000, 40000];
      },
    },
    {
      title: 'infoCard',
      dataIndex: 'name',
      type: 'infoCard',
      width: 300,
      getValue(record, index) {
        return {
          title: record.name,
          info: record.subTitle,
          image: record.image,
        };
      },
    },
    {
      title: 'text',
      dataIndex: 'name',
      typeProps: {
        style: {
          paddingRight: 10,
        },
        copyable: true,
      },
    },
    {
      title: '上下文 appId',
      dataIndex: 'appId',
    },
    {
      title: 'tag',
      width: 200,
      getValue: record => '数据',
      type: 'tag',
    },
    {
      title: '多个tag',
      width: 200,
      type: 'array',
      itemType: 'tag',
      getValue: record => [
        '数据',
        {
          text: '我的天呢',
          type: 'warn',
        },
      ],
    },
    {
      title: 'enum',
      type: 'enum',
      dataIndex: 'status',
      enums: [
        { label: '初始化', value: 1, type: 'cancel' },
        { label: '错误', value: 2, type: 'error' },
        { label: '已完成', value: 3, type: 'success' },
        { label: '处理中', value: 4, type: 'warn' },
      ],
      remarkIndex: 'remark', // remark字段值为空不会展示备注的图标
    },
    {
      title: 'price',
      // type对应单位 cent对应 分 yuan对应 元
      type: 'cent',
      dataIndex: 'price',
      remarkIndex: 'remark',
    },
    {
      dataIndex: 'date',
      title: 'date',
      type: 'date',
      width: 160,
    },
    {
      title: 'dateRange',
      dataIndex: 'dateRange',
      type: 'dateRange',
      width: 300,
    },
    {
      title: 'link',
      dataIndex: 'image',
      type: 'link',
      typeProps: {
        icon: false,
      },
    },
    {
      title: '多个link',
      dataIndex: 'image',
      type: 'array',
      itemType: 'link',
      getValue(record, index, ctx) {
        return [record.image, record.image, record.image, record.image];
      },
      typeProps: {
        maxCount: 3,
      },
      itemTypeProps: {
        icon: false,
      },
      width: 200,
    },
    {
      title: 'image',
      dataIndex: 'image',
      type: 'image',
      width: 200,
      typeProps: {
        width: '100%',
      },
    },
    {
      title: '多个image',
      dataIndex: 'image',
      type: 'array',
      itemType: 'image',
      getValue(record, index, ctx) {
        return [record.image, record.image];
      },
      typeProps: {
        wrap: false,
        direction: 'vertical',
      },
      itemTypeProps: {
        height: 30,
      },
    },
    {
      type: 'operation',
      title: 'operation',
      fixed: 'right',
      width: 200,
      operations: [
        {
          name: '详情',
          action: {
            onClick: (record, index, ctx) => {
              Modal.info({
                title: 'mock详情',
                content: '内容',
              });
            },
          },
        },
        {
          name: '删除',
          action: {
            confirm: {
              title: '确定删除？',
              mode: 'Popconfirm',
            },
            onClick: record => {
              return true;
            },
            successTips: '删除成功',
          },
          show: (record, i) => i === 0,
        },
        {
          disabled: () => true,
          name: '操作1',
          action: {
            onClick: record => {
              Modal.info({ title: 'mock其他操作', content: '内容' });
            },
          },
        },
        {
          name: '其他操作2',
          href: () => 'https://baidu.com',
        },
      ],
    },
  ];

  const data = Array(2)
    .fill(1)
    .map((_, i) => ({
      name: '黑椒猪排，蒜蓉粉丝扇贝',
      time: 1686021930556,
      subTitle: '副标题副标题副标题副标题',
      status: ~~(Math.random() * 4) + 1,
      price: 1000,
      longText: '超长文字超长文字超长文字超长文字超长文字超长文字超长',
      image:
        'https://tosv.boe.byted.org/obj/ecom-open-butler/prod/temp/img_15983366583419.png',
      id: i,
      app: {
        name: 'appName',
        id: i,
      },
      user: {
        name: 'zhangsan',
        avatar:
          'https://tosv.boe.byted.org/obj/ecom-open-butler/prod/temp/img_15983366583419.png',
      },
      remark: i < 4 ? '这是一个备注' : '',
      dateRange: [1686021930556 / 1000, 1686021930556 / 1000],
      date: 1686021930556,
      num: 828918291829.21,
    }));


  return <ProTable
    fixed
    data-test="ls3koo"
    ctx={{ appId: '7225125443366553125' }}
    rowKey={'id'}
    dataSource={data}
    style={{whiteSpace: 'pre-wrap'}}
    columns={columns}
  />

}

  